import { render, staticRenderFns } from "./DaliDimmingInfo.vue?vue&type=template&id=13ca1920&scoped=true"
import script from "./DaliDimmingInfo.vue?vue&type=script&lang=ts"
export * from "./DaliDimmingInfo.vue?vue&type=script&lang=ts"
import style0 from "./DaliDimmingInfo.vue?vue&type=style&index=0&id=13ca1920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca1920",
  null
  
)

export default component.exports